/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SalesJourney,
    SalesJourneyFromJSON,
    SalesJourneyFromJSONTyped,
    SalesJourneyToJSON,
} from './';

/**
 * 
 * @export
 * @interface SalesJourneyCriteriaRequest
 */
export interface SalesJourneyCriteriaRequest {
    /**
     * 
     * @type {SalesJourney}
     * @memberof SalesJourneyCriteriaRequest
     */
    value?: SalesJourney;
    /**
     * 
     * @type {boolean}
     * @memberof SalesJourneyCriteriaRequest
     */
    exclude?: boolean;
}

export function SalesJourneyCriteriaRequestFromJSON(json: any): SalesJourneyCriteriaRequest {
    return SalesJourneyCriteriaRequestFromJSONTyped(json, false);
}

export function SalesJourneyCriteriaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesJourneyCriteriaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : SalesJourneyFromJSON(json['value']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function SalesJourneyCriteriaRequestToJSON(value?: SalesJourneyCriteriaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': SalesJourneyToJSON(value.value),
        'exclude': value.exclude,
    };
}


